import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/framework/service/snack-bar.service';
import { PatientService } from '../patient/patient.service';

interface Consent {
  id: number;
  identifier: string;
  description: string;
  mandatory: boolean;
}
@Component({
  selector: 'app-patient-consent',
  templateUrl: './patient-consent.component.html',
  styleUrls: ['./patient-consent.component.scss']
})
export class PatientConsentComponent implements OnInit {
  consentForm: FormGroup;
  consents: Consent[] = [];
  myFocusVar: boolean = false;

  mandatoryIdentifiers = [
    'InformedAboutDNA',
    'UnderstandsTest',
    'ConsentSampleCollection',
    'VoluntaryTest',
    'ConsentStorageUK',
    'DataAccessResults'
  ];
  
  constructor(
    private readonly pservice: PatientService,
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly snackBar: SnackBarService,
    public dialogRef: MatDialogRef<PatientConsentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {

    this.consentForm = this.fb.group({});

    const consentIdentifier = 'PC';
    this.pservice.getAllPatientsConsent(consentIdentifier).subscribe(data => {
      this.consents = data;
      data.forEach(c => {
        const isMandatory = this.mandatoryIdentifiers.includes(c.identifier);
        c.mandatory = isMandatory;
        this.consentForm.addControl(
          'consent_' + c.id, 
           this.fb.control(false, isMandatory ? Validators.requiredTrue : []));
      });
    });
  }

  onSubmit(consentForm){
    if (this.consentForm.valid) {
      const payload = this.buildPayload();
      
      this.pservice.addPatientConsent(payload).subscribe((rsp) => {
        this.dialogRef.close(true);
        this.snackBar.success("Success! Consent added successfully.");
      }, error => {
        this.showErrorMsg(error, consentForm);
      })
    }
  }

  
private buildPayload() {
  const formValues = this.consentForm.value;

  const consentIdList = Object.keys(formValues)
    .filter(key => formValues[key] === true)
    .map(key => Number(key.replace('consent_', '')));

  return {
    patientId: this.data.patientId,
    consentIdList
  };
}

  private showErrorMsg(error: any, consentForm: any) {
    if (error.error.errors) {
      error.error.errors.forEach(element => {
        this.displayError(consentForm, element);
      });
    } else {
      this.snackBar.error(error.error.applicationMessage);
    }
  }
  private displayError(consentForm: any, element: any) {
    consentForm.get(element.field).setErrors({ errorMessage: element.errorMessage });
  }
  onFocusEvent(event: any){
    this.myFocusVar = true;
  }
}
